import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { m } from '@/paraglide/messages.js';
import { reportError } from '@/lib/reportError.ts';
import { stopImpersonation } from '@wundo/client/impersonation.ts';

export const Route = createFileRoute('/stop-impersonating')({
  component: StopImpersonatingPage,
});

/*
 * Where "stop" lands, from the banner and from the account menu. A route of
 * its own for the same reason /logout is one: what follows is a full page
 * navigation, so nothing cached for the impersonated user survives into the
 * staff member's own session.
 */
export function StopImpersonatingPage() {
  useEffect(() => {
    /* Home either way: whoever this is lands on their own start page. */
    void stopImpersonation()
      .catch((error: unknown) => reportError(error, { action: 'stopImpersonation' }))
      .finally(() => {
        window.location.assign('/');
      });
  }, []);

  return (
    <main className='flex h-dvh items-center justify-center'>
      <p className='text-md text-ink-muted'>{m.impersonation_stopping()}</p>
    </main>
  );
}
